import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ProjectElement } from '../models/project.model';
import { ProjectService } from './../services/project.service';
import { MenusComponent } from './../menus/menus.component';
import { MatPaginator } from '@angular/material/paginator';
import { StorageService } from '../services/storage.service';

const lstProjects: ProjectElement[] = [];

@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrl: './projects.component.css'
})


export class ProjectsComponent implements OnInit {

  private rowClick$  = new Subject<ProjectElement>();

  displayedColumns: string[] = ['id', 'name', 'zone_name', 'start_date', 'country'];

  displayedColumns2: string[] = ['id', 'name', 'zone_name', 'start_date', 'country', 'company_id' ];

  dataSource = new MatTableDataSource(lstProjects);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  
  constructor(private router: Router, private projectService: ProjectService,
              private menusComponent: MenusComponent, public storageService: StorageService ) { }

  isLoading = false;

  @ViewChild(MatSort)
  sort: MatSort = new MatSort;
  public superAdm = false;

  items: any = [];

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.paginator._intl.itemsPerPageLabel="Registros por página";
    this.dataSource.paginator = this.paginator;
  }

  ngOnInit(): void {
    this.rowClick$.subscribe(
      row => console.log('[row clicked]', row)
    );
    this.isLoading = true;
    this.loadProjects();
    this.isLoading = false;
  }

  loadProjects():void {
    const req=this.projectService.getAllProjects(this.storageService.companyId);
    req.subscribe({
      next: (res) => {
        this.items = res;
        this.dataSource.data=this.items.data;
      },
      error: (e) => {
        console.error(e);
        let msg = e.error.message;
      },
    });
  }

  onRowClicked(row: ProjectElement): void {
    console.log("[onRowClicked] row clicked", row);
    this.rowClick$.next(row);
    this.router.navigate(['project'], { queryParams: { id: row.id, companyId: row.company_id } });
  }

}
